module.exports = __webpack_public_path__ + "img/12.fff07e64.jpg";